import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Device } from 'mbs-ui-shared@models/device';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DevicesService {
  private http = inject(HttpClient);

  getDevices(): Observable<Array<Device>> {
    return this.http.get<Array<Device>>('api/v2/devices');
  }

  addDevice(tfa = true): Observable<{
    qrCodeUrl: string;
    timeExpired: string;
  }> {
    return this.http.get<{
      qrCodeUrl: string;
      timeExpired: string;
    }>(`api/v2/devices/qr?tfa=${tfa}`);
  }

  deleteDevice(id: string, hasTwoFactorAuth: boolean) {
    return this.http.delete(`api/v2/devices/${id}`);
  }

  editDevice(data: { deviceId: string; push: boolean; tfa: boolean }) {
    return this.http.put('api/v2/devices/settings', data);
  }

  enablePush(id: string) {
    return this.http.put('api/v2/devices/push-settings', { DeviceId: id, Enable: true });
  }

  disablePush(id: string) {
    return this.http.put('api/v2/devices/push-settings', { DeviceId: id, Enable: false });
  }

  enableTFA(id: string): any {
    return this.http.put('api/v2/devices/tfa/on', { DeviceId: id });
  }

  disableTFA(id: string) {
    return this.http.put<{ redirectUrl: string }>('api/v2/devices/tfa/off', { DeviceId: id });
  }

  recoverPassword(hid, backupPath) {
    return this.http.post('api/backup-plans/recover-password', { hid, backupPath });
  }
}
